module.exports = __webpack_public_path__ + "media/images/visa-bca1b1792c034aa80fb2efe77f28b7e5.png";